export default "__VITE_ASSET__D8QHiv8F__"